import { $http } from '../request'
import domain from '../../server-config/domain.config'

/** 获取店铺信息 */
export const getStoreInfo = (storeId: number | string, server: boolean = false) => {
  return $http.get({
    url: `/store/${storeId}`,
    server
  })
}

export const getStoreInfoByAlias = (storeAlias: string, server: boolean = false) => $http.get({
  url: `/store_by_alias/${storeAlias}`,
  server
})

/** 关注店铺 */
export const postFollow = (storeId: number | string) => {
  return $http.post({
    url: `/store/${storeId}/follow`,
    loading: true
  })
}

/** 取消关注店铺 */
export const deleteFollow = (storeId: number | string) => {
  return $http.delete({
    url: `/store/${storeId}/follow`,
    loading: true
  })
}

/** 获取店铺推荐商品 */
export const getRecommendedProduct = (storeId: number | string, server: boolean = false) => {
  return $http.get({
    url: `/store/${storeId}/recommended`,
    loading: !server,
    server,
  })
}

/** 获取店铺所有商品 */
export const getStoreAllProducts = (
  storeId: number | string,
  params: any,
  loading: boolean=true,
  server: boolean = false
) => {
  return $http.get({
    url: `/store/${storeId}/search`,
    query: params,
    loading: !server && loading,
    server
  })
}

/** 获取商品分类 */
export const getStoreCategories = (storeId: number | string, server: boolean = false) => {
  return $http.get({
    url: `/store/${storeId}/categories`,
    loading: !server,
    server
  })
}

export const storeCMSConfig = (storeId: number, countryCode: string) => {
  const url = domain.HW_OBS_STORE_CMS_URL
    .replace('{storeId}', String(storeId))
    .replace('{countryCode}', countryCode.toLocaleUpperCase())
    
  return $http.get({
    url,
    server: true
  })
}